"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateOperation = exports.UpdateOperationSymbol = void 0;
var engine_utils_1 = require("@verified/c11-engine.utils");
var isArray_1 = __importDefault(require("lodash/isArray"));
var getInvokablePath_1 = require("./getInvokablePath");
exports.UpdateOperationSymbol = Symbol("update");
var updateOperation = function (db, structure, op) {
    var set = function (value, params) {
        var path = (0, getInvokablePath_1.getInvokablePath)(structure, op, params);
        if (path) {
            var patch = {
                op: "add",
                path: path,
                value: value,
            };
            db.patch([patch]);
        }
    };
    var merge = function (value, params) {
        var path = (0, getInvokablePath_1.getInvokablePath)(structure, op, params);
        if (path) {
            var patch = {
                op: "merge",
                path: path,
                value: value,
            };
            var val = db.get(path);
            if (!val) {
                db.patch([
                    {
                        op: "add",
                        path: path,
                        value: {},
                    },
                ]);
            }
            db.patch([patch]);
        }
    };
    var remove = function (params) {
        var path = (0, getInvokablePath_1.getInvokablePath)(structure, op, params);
        if (path) {
            var patch = {
                op: "remove",
                path: path,
            };
            db.patch([patch]);
        }
    };
    var push = function (value, params) {
        var path = (0, getInvokablePath_1.getInvokablePath)(structure, op, params);
        if (path) {
            var val = db.get(path);
            if (val === undefined) {
                val = [];
            }
            else if (!(0, isArray_1.default)(val)) {
                // console.error("path is not an array");
                return;
            }
            val.push(value);
            var patch = {
                op: "add",
                path: path,
                value: val,
            };
            db.patch([patch]);
        }
    };
    var pop = function (params) {
        var path = (0, getInvokablePath_1.getInvokablePath)(structure, op, params);
        if (path) {
            var val = db.get(path);
            if (!(0, isArray_1.default)(val)) {
                // console.error('path is not an array')
                return;
            }
            val.pop();
            var patch = {
                op: "add",
                path: path,
                value: val,
            };
            db.patch([patch]);
        }
    };
    var operation = {
        set: set,
        merge: merge,
        remove: remove,
        push: push,
        pop: pop,
        __operation__: {
            id: (0, engine_utils_1.randomId)(),
            symbol: exports.UpdateOperationSymbol,
            path: op.path,
        },
    };
    return operation;
};
exports.updateOperation = updateOperation;
//# sourceMappingURL=data:application/json;base64,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